"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("modules/dom");
require("./faq-page.scss");
(0, dom_1.documentHasElements)(".js-faq-page", function () {
    var faqPage = {
        init: function () {
            faqPage.addLinkList();
            faqPage.wrapAccordions();
            faqPage.addSmoothScroll();
        },
        addLinkList: function () {
            var blocks = document.querySelectorAll(".faq-blocks > .accordion-block");
            var tabs = document.querySelector(".faq-list");
            blocks.forEach(function (block) {
                var listItem = document.createElement("li");
                var listLink = document.createElement("a");
                var blockId = block.getAttribute("id");
                if (blockId !== null) {
                    listLink.innerHTML = blockId.toString();
                    listLink.setAttribute("href", "#" + blockId.toString());
                    listItem.appendChild(listLink);
                }
                if (listItem && tabs) {
                    tabs.appendChild(listItem);
                }
            });
        },
        wrapAccordions: function () {
            var blocks = document.querySelectorAll(".faq-blocks > .accordion-block");
            blocks.forEach(function (block, i) {
                if (i % 2 === 0) {
                    var wrapper = document.createElement("div");
                    wrapper.classList.add("accordion-block__dark");
                    if (block.parentNode !== null) {
                        block.parentNode.insertBefore(wrapper, block);
                        wrapper.appendChild(block);
                    }
                }
            });
        },
        addSmoothScroll: function () {
            var html = document.querySelector("html");
            if (html) {
                html.classList.add("html-scroll__smooth");
            }
        },
    };
    faqPage.init();
});
